// extracted by mini-css-extract-plugin
module.exports = {"img_element":"PromoImage_img_element__kR6_7"};